import React from 'react';

// Component Styles
import './spinner.scss';
import AppConfiguration from '../../../services/AppConfiguration';

/**
 * This component display a spinner component
 */
function Spinner() {
  const appConfig = AppConfiguration.getConfig();
  return (
    <div>
      <img src={`${appConfig.cdnUrl.url}/spinner_icon.gif`} alt='Loading...' className='wtfSpinner' />
    </div>
  );
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner/Spinner.js